import {createReducer, createAction} from 'redux-act';

import {toggleSearch} from 'reducers/header/header';

export type WizardPopupType = {
    isOpen: boolean;
};

export const initialState = {
    isOpen: false,
};

export const setVisibleWizardPopup = createAction<boolean>('WIZARD_SET_VISIBLE_POPUP');

/**
 * Determines state of wizard popup
 */
export const wizardPopup = createReducer<WizardPopupType>({}, initialState)
    .on(
        `${setVisibleWizardPopup}`,
        (state: WizardPopupType, isOpen: boolean): WizardPopupType => {
            return {...state, isOpen};
        },
    )
    .on(`${toggleSearch}`, () => ({isOpen: false}));
